export default __webpack_public_path__ + "static/media/Bottom Navigation.a0ada295.svg";